/**
 * Shared payer-chip color map for the Billing News surfaces.
 *
 * InsightsListPage and InsightDetailPage both render payer chips with the
 * same brand-tinted color tokens. Previously duplicated across both files;
 * consolidated here to keep the two surfaces visually in lockstep.
 */

export const PAYER_COLORS: Record<string, { color: string; bg: string }> = {
  UHC: { color: "hsl(210 70% 42%)", bg: "hsl(210 70% 42% / 0.07)" },
  Aetna: { color: "hsl(270 50% 48%)", bg: "hsl(270 50% 48% / 0.07)" },
  BCBS: { color: "hsl(210 80% 45%)", bg: "hsl(210 80% 45% / 0.07)" },
  CMS: { color: "hsl(210 60% 40%)", bg: "hsl(210 60% 40% / 0.07)" },
  Medicare: { color: "hsl(170 45% 38%)", bg: "hsl(170 45% 38% / 0.07)" },
  Medicaid: { color: "hsl(170 40% 40%)", bg: "hsl(170 40% 40% / 0.07)" },
  Cigna: { color: "hsl(24 75% 45%)", bg: "hsl(24 75% 45% / 0.07)" },
  Humana: { color: "hsl(145 50% 38%)", bg: "hsl(145 50% 38% / 0.07)" },
  Anthem: { color: "hsl(220 60% 45%)", bg: "hsl(220 60% 45% / 0.07)" },
  Molina: { color: "hsl(200 55% 40%)", bg: "hsl(200 55% 40% / 0.07)" },
  Kaiser: { color: "hsl(350 55% 45%)", bg: "hsl(350 55% 45% / 0.07)" },
};

export const DEFAULT_PAYER_COLOR = {
  color: "hsl(var(--foreground) / 0.50)",
  bg: "hsl(var(--foreground) / 0.04)",
};

export function formatPulseDate(dateStr: string): string {
  const d = new Date(dateStr + "T12:00:00");
  return d.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}
